export default "__VITE_ASSET__DEoJlfbN__"